import React, { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL;

const getHomeUrl = () => {
  const isLocalDev = API_URL.includes("localhost") || API_URL.includes("127.0.0.1");
  if (isLocalDev) {
    const url = new URL(API_URL);
    return `${url.protocol}//${url.hostname}:3001`;
  }
  return "https://games.precisionpros.com";
};

const HowToPlayPage = () => {
  const [demoStep, setDemoStep] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setDemoStep((prev) => (prev + 1) % 10);
    }, 1800);
    return () => clearInterval(timer);
  }, []);

  const styles = {
    pageWrapper: {
      minHeight: "100vh",
      backgroundColor: "#fafbfc",
      padding: "20px 12px 40px 12px",
    },
    cardContainer: {
      maxWidth: "600px",
      margin: "0 auto",
      backgroundColor: "white",
      borderRadius: "16px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 8px 24px rgba(0, 0, 0, 0.06)",
      padding: "32px 24px",
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "28px",
    },
    icon: {
      width: "40px",
      height: "40px",
      backgroundColor: "#2563eb",
      borderRadius: "6px",
      border: "2px solid rgba(0,0,0,0.12)",
      boxShadow: "inset 0 -3px 0 rgba(0,0,0,0.18)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    iconText: {
      color: "white",
      fontFamily: "'Inter', sans-serif",
      fontWeight: "900",
      fontSize: "1.2rem",
      letterSpacing: "-0.02em",
      lineHeight: 1,
    },
    title: {
      fontSize: "2rem",
      margin: 0,
      fontFamily: "'Inter', sans-serif",
      lineHeight: 1,
      letterSpacing: "-0.03em",
    },
    titleSpan: {
      color: "#333",
      fontWeight: "500",
    },
    titleSpanBlue: {
      color: "#2563eb",
      fontWeight: "900",
    },
    section: {
      marginBottom: "32px",
    },
    sectionTitle: {
      fontSize: "1.1rem",
      fontWeight: "800",
      color: "#0a0a0a",
      marginBottom: "14px",
      marginTop: "0",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    description: {
      fontSize: "0.95rem",
      color: "#555",
      lineHeight: "1.6",
      marginBottom: "12px",
    },
    demoBox: {
      backgroundColor: "#f8f9fa",
      border: "1px solid #e5e7eb",
      borderRadius: "12px",
      padding: "16px",
      marginTop: "12px",
    },
    wordRow: {
      display: "flex",
      gap: "2px",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      marginBottom: "14px",
    },
    wordBox: {
      padding: "12px 14px",
      backgroundColor: "white",
      border: "2px solid #e5e7eb",
      borderRadius: "8px",
      fontSize: "0.9rem",
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "1px",
      minWidth: "70px",
      textAlign: "center",
      transition: "all 0.4s ease",
    },
    wordBoxStart: {
      backgroundColor: "#fff3cd",
      borderColor: "#ffc107",
      color: "#856404",
    },
    wordBoxEnd: {
      backgroundColor: "#c8e6c9",
      borderColor: "#4CAF50",
      color: "#2e7d32",
    },
    wordBoxCorrect: {
      backgroundColor: "#f0fdf4",
      borderColor: "#16a34a",
      color: "#16a34a",
    },
    wordBoxActive: {
      backgroundColor: "#eff6ff",
      borderColor: "#2563eb",
      borderWidth: "2px",
      boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.1)",
    },
    plus: {
      color: "#999",
      fontSize: "1rem",
      margin: "0 6px",
      fontWeight: "700",
    },
    connection: {
      fontSize: "0.75rem",
      fontWeight: "700",
      color: "#2563eb",
      marginTop: "6px",
      fontFamily: "monospace",
      letterSpacing: "0.5px",
      backgroundColor: "#eff6ff",
      padding: "4px 8px",
      borderRadius: "4px",
      display: "inline-block",
    },
    stepList: {
      listStyle: "none",
      padding: "0",
      margin: "0",
    },
    stepItem: {
      padding: "12px",
      marginBottom: "10px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      borderLeft: "4px solid #2563eb",
      fontSize: "0.95rem",
      color: "#333",
    },
    stepNumber: {
      fontWeight: "800",
      color: "#2563eb",
      marginRight: "8px",
    },
    exampleCard: {
      backgroundColor: "#eff6ff",
      border: "1px solid #bfdbfe",
      borderRadius: "8px",
      padding: "12px",
      marginTop: "10px",
      fontSize: "0.9rem",
      color: "#1e40af",
    },
    hintsBox: {
      backgroundColor: "#fef3c7",
      border: "1px solid #fcd34d",
      borderRadius: "8px",
      padding: "12px",
      marginTop: "10px",
    },
    hintSequence: {
      fontFamily: "monospace",
      fontSize: "0.95rem",
      fontWeight: "700",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      marginBottom: "8px",
      padding: "8px",
      backgroundColor: "white",
      borderRadius: "4px",
      border: "1px solid #fcd34d",
    },
    hintRevealed: {
      color: "#16a34a",
      fontWeight: "800",
    },
    hintHidden: {
      color: "#bfbfbf",
    },
    backButton: {
      display: "inline-block",
      marginTop: "24px",
      padding: "12px 20px",
      backgroundColor: "#f3f4f6",
      color: "#333",
      textDecoration: "none",
      borderRadius: "8px",
      fontWeight: "700",
      fontSize: "0.9rem",
      border: "1.5px solid #d3d6da",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
  };

  // Example: EYE → WASH → DAY (EYEWASH, WASHDAY)
  const demoChain = [
    { word: "EYE", type: "start" },
    { word: "WASH", type: "guess", connection: "EYEWASH" },
    { word: "DAY", type: "end", connection: "WASHDAY" },
  ];

  const hintExample = "WASH";

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.cardContainer}>
        {/* Back Button */}
        <button onClick={() => { window.location.href = getHomeUrl(); }} style={{ ...styles.backButton, marginBottom: "20px" }}>
          Home
        </button>

        {/* Header */}
        <div style={styles.header}>
          <div style={styles.icon}>
            <span style={styles.iconText}>C</span>
          </div>
          <h1 style={styles.title}>
            <span style={styles.titleSpan}>Connect</span>
            <span style={styles.titleSpanBlue}>Pro</span>
          </h1>
        </div>

        <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "28px", fontWeight: "500" }}>
          How to play
        </p>

        {/* Objective Section */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>🎯 The Objective</p>
          <p style={styles.description}>
            Find the words that semantically connect a start word to an end word. Each word you guess must form a meaningful connection (compound word, phrase, or expression) with both the previous and next word.
          </p>

          <div style={styles.demoBox}>
            {/* Start Word */}
            <div style={{ textAlign: "center", marginBottom: "12px" }}>
              <span style={{ display: "inline-block", padding: "8px 14px", backgroundColor: "#f0f2f5", borderRadius: "24px", fontSize: "13px", fontWeight: "800", color: "#0a0a0a", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                EYE
              </span>
            </div>

            {/* Word Inputs */}
            {/* Row 1 - Correct (green) */}
            <div style={{ display: "flex", gap: "6px", alignItems: "center", marginBottom: "4px" }}>
              <div style={{ flex: 1, padding: "12px 14px", backgroundColor: "#f0fdf4", border: "2px solid #16a34a", borderRadius: "8px", fontSize: "0.9rem", fontWeight: "800", textTransform: "uppercase", letterSpacing: "1px", textAlign: "center" }}>
                WASH
              </div>
              <button style={{ padding: "6px 8px", fontSize: "16px", border: "1.5px solid #e5e7eb", borderRadius: "8px", backgroundColor: "#f3f4f6", cursor: "not-allowed", color: "#ccc", fontWeight: "600", minHeight: "50px", minWidth: "50px" }}>
                💡
              </button>
            </div>

            {/* Row 2 - Wrong (red) */}
            <div style={{ display: "flex", gap: "6px", alignItems: "center", marginBottom: "12px" }}>
              <div style={{ flex: 1, padding: "12px 14px", backgroundColor: "#fef2f2", border: "2px solid #dc2626", borderRadius: "8px", fontSize: "0.9rem", fontWeight: "800", textTransform: "uppercase", letterSpacing: "1px", textAlign: "center", color: "#dc2626" }}>
                NIGHT
              </div>
              <button style={{ padding: "6px 8px", fontSize: "16px", border: "1.5px solid #e5e7eb", borderRadius: "8px", backgroundColor: "#ffffff", cursor: "pointer", color: "#333", fontWeight: "600", minHeight: "50px", minWidth: "50px" }}>
                💡
              </button>
            </div>

            {/* End Word */}
            <div style={{ textAlign: "center", marginBottom: "12px" }}>
              <span style={{ display: "inline-block", padding: "8px 14px", backgroundColor: "#f0f2f5", borderRadius: "24px", fontSize: "13px", fontWeight: "800", color: "#0a0a0a", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                BED
              </span>
            </div>

            {/* Submit Button */}
            <button style={{ width: "100%", padding: "14px 16px", fontSize: "15px", fontWeight: "700", border: "none", borderRadius: "10px", cursor: "pointer", textTransform: "uppercase", letterSpacing: "0.6px", height: "48px", backgroundColor: "#2563eb", color: "white", marginBottom: "12px" }}>
              Submit
            </button>

            {/* Results Explanation */}
            <div style={{ padding: "12px", backgroundColor: "#f8f9fa", borderRadius: "8px", fontSize: "0.85rem" }}>
              <p style={{ margin: "0 0 8px 0", color: "#16a34a", fontWeight: "600" }}>
                ✓ <strong>Green:</strong> Correct word
              </p>
              <p style={{ margin: "0", color: "#dc2626", fontWeight: "600" }}>
                ✗ <strong>Red:</strong> Incorrect word (keep trying!)
              </p>
            </div>
          </div>
        </div>

        {/* How It Works */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>⚙️ How It Works</p>
          <p style={styles.description}>
            You're given a start word and an end word. You need to find intermediate words where:
          </p>
          <ul style={styles.stepList}>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>1.</span>
              Word A + your guess = a compound word, phrase, or valid expression
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>2.</span>
              Your guess + next word = another compound word, phrase, or valid expression
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>3.</span>
              The chain eventually connects to the end word
            </li>
          </ul>
        </div>

        {/* Gameplay Section */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>⌨️ Playing the Game</p>
          <ul style={styles.stepList}>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>1.</span>
              Type your guesses in each empty word row
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>2.</span>
              Move between rows using Tab or by clicking on them
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>3.</span>
              Click Submit anytime to check your answers (optional — you can submit partially filled!)
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>4.</span>
              Correct words turn <span style={{ color: "#16a34a", fontWeight: "700" }}>green</span> and lock
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>5.</span>
              Incorrect or empty words turn <span style={{ color: "#dc2626", fontWeight: "700" }}>red</span> — keep trying!
            </li>
            <li style={styles.stepItem}>
              <span style={styles.stepNumber}>6.</span>
              <strong>Pro tip:</strong> Fill all words before submitting for a better leaderboard score
            </li>
          </ul>
        </div>

        {/* Hints Section */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>💡 Using Hints</p>
          <p style={styles.description}>
            Stuck? Click the 💡 button to reveal the answer letter by letter. You can use multiple hints per word to gradually discover the correct answer.
          </p>

          <div style={styles.hintsBox}>
            <p style={{ fontSize: "0.8rem", fontWeight: "600", color: "#78350f", textTransform: "uppercase", letterSpacing: "0.5px", marginTop: "0", marginBottom: "10px" }}>
              💡 Example: Hints for "WASH"
            </p>

            {/* Progressive hint reveals */}
            {["W", "WA", "WAS", "WASH"].map((hint, idx) => (
              <div key={idx} style={{ marginBottom: idx === 3 ? "0" : "8px" }}>
                <div style={styles.hintSequence}>
                  {hint.split("").map((letter, lidx) => (
                    <span key={lidx} style={styles.hintRevealed}>
                      {letter}
                    </span>
                  ))}
                  {hint.length < 4 &&
                    "_".repeat(4 - hint.length).split("").map((_, lidx) => (
                      <span key={`h${lidx}`} style={styles.hintHidden}>
                        _
                      </span>
                    ))}
                </div>
                {idx < 3 && (
                  <p style={{ fontSize: "0.75rem", color: "#b45309", margin: "0", fontWeight: "500" }}>
                    💡 Hint {idx + 1}
                  </p>
                )}
                {idx === 3 && (
                  <p style={{ fontSize: "0.75rem", color: "#16a34a", margin: "0", fontWeight: "600" }}>
                    ✓ Word revealed!
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Leaderboard Section */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>🏆 Leaderboard Rankings</p>
          <p style={styles.description}>
            The leaderboard separates players into two groups based on hint usage:
          </p>

          <div style={styles.exampleCard}>
            <p style={{ margin: "0 0 12px 0", fontWeight: "600", fontSize: "0.95rem" }}>
              Perfect Runs (🥇 Top Tier)
            </p>
            <ul style={{ margin: "0 0 12px 0", paddingLeft: "20px", color: "#1e40af" }}>
              <li>Solved with <strong>zero hints</strong></li>
              <li>Ranked by <strong>fastest time</strong></li>
            </ul>

            <p style={{ margin: "0 0 12px 0", fontWeight: "600", fontSize: "0.95rem" }}>
              Hint-Assisted Runs (💡 Second Tier)
            </p>
            <ul style={{ margin: "0 0 0 0", paddingLeft: "20px", color: "#1e40af" }}>
              <li>Used hints OR didn't solve the puzzle</li>
              <li>Ranked by: <strong>fewest hints</strong> → <strong>fastest time</strong> → <strong>fewest guesses</strong></li>
            </ul>
          </div>

          <p style={{ ...styles.description, marginTop: "16px" }}>
            <strong>Pro tip:</strong> To achieve a better ranking, solve the puzzle without hints. If you do need hints, fewer hints = better rank!
          </p>
        </div>

        {/* Tips Section */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>🧠 Strategy Tips</p>
          <ul style={styles.stepList}>
            <li style={styles.stepItem}>
              Think about common compound words (HAIR + CUT = HAIRCUT)
            </li>
            <li style={styles.stepItem}>
              Consider phrases and phrasal verbs (SET + OFF = SET OFF)
            </li>
            <li style={styles.stepItem}>
              Look for words that can form meaningful connections in both directions
            </li>
            <li style={styles.stepItem}>
              Use hints strategically to narrow down possibilities
            </li>
          </ul>
        </div>

        {/* Rules Section */}
        <div style={styles.section}>
          <p style={styles.sectionTitle}>📋 Rules</p>
          <ul style={styles.stepList}>
            <li style={styles.stepItem}>
              Each word must form a semantic connection with the previous word
            </li>
            <li style={styles.stepItem}>
              All words must be valid English words
            </li>
            <li style={styles.stepItem}>
              You can only play one puzzle per day
            </li>
            <li style={styles.stepItem}>
              Your score depends on time, guesses, and hints used
            </li>
          </ul>
        </div>

        {/* Back Link */}
        <div>
          <button onClick={() => { window.location.href = "https://games.precisionpros.com"; }} style={styles.backButton}>
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayPage;
